export enum PolicyModificationNames {
	'modification.policy.create' = 'Policy Creation',
	'modification.policy.renew' = 'Renewal',
	'modification.policy.cancel' = 'Cancellation',
	'modification.policy.withdraw' = 'Withdrawal',
	'modification.policy.lapse' = 'Lapse',
	'modification.policy.reinstate' = 'Reinstatement',
}
